module.exports = __webpack_public_path__ + "assets/img/142.f6343efb.png";